// extracted by mini-css-extract-plugin
export var deleteModal = "_iv-0";